import HttpService from "../../../axiosConfig/http.service";

export default class CaseStudyService extends HttpService {
  createCaseStudy = async (data) => {
    try {
      let response = await this.postRequest("/v1/caseStudy", data, {
        auth: true,
        file: true,
      });
      return response;
    } catch (exception) {
      throw exception;
    }
  };

  listAllCaseStudy = async (perPage = 3, page = 1) => {
    try {
      let response = await this.getRequest(
        "/v1/caseStudy?perPage=" + perPage + "&page" + page
      );
      return response;
    } catch (exception) {
      throw exception;
    }
  };

  getCaseStudyDetail = async (slug) => {
    try {
      let response = await this.getRequest("/v1/caseStudy/" + slug + "/detail");
      return response;
    } catch (exception) {
      throw exception;
    }
  };

  deleteCaseStudy = async (id) => {
    try {
      let response = await this.deleteRequest("/v1/caseStudy/" + id, {
        auth: true,
      });
      return response;
    } catch (exception) {
      throw exception;
    }
  };

  updateCaseStudy = async (data, id) => {
    try {
      let response = await this.putRequest("/v1/caseStudy/" + id, data, {
        auth: true,
        file: true,
      });
      return response;
    } catch (exception) {
      throw exception;
    }
  };

  getCaseStudyById = async (id) => {
    try {
      let response = await this.getRequest("/v1/caseStudy/" + id, {
        auth: true,
      });
      return response;
    } catch (exception) {
      throw exception;
    }
  };
}
